// Embed-mode helpers. When the app runs inside the partner portal's iframe it is
// launched at /dashboard?embed=1 (by the /sso redirect). We persist that in
// sessionStorage so the mode survives client-side navigation without threading
// ?embed=1 through every link. sessionStorage is per-tab, so normal (non-embed)
// use in other tabs is unaffected.

// Allowed portal origin(s), used to target/validate postMessage. Set at build
// time as a comma-separated list, e.g.
//   REACT_APP_PORTAL_ORIGIN=https://partners.v2cloud.com,https://v2cloud-4366063.hs-sites.com
export const PORTAL_ORIGINS = (process.env.REACT_APP_PORTAL_ORIGIN || '')
  .split(',').map(s => s.trim()).filter(Boolean);
// Back-compat single value (first configured origin).
export const PORTAL_ORIGIN = PORTAL_ORIGINS[0] || '';

// Is an inbound message from an allowed portal origin? (If none configured, allow
// any — dev only.)
export function isAllowedPortalOrigin(origin) {
  return PORTAL_ORIGINS.length === 0 || PORTAL_ORIGINS.includes(origin);
}

let _cached = null;

export function isEmbed() {
  if (_cached !== null) return _cached;
  try {
    const fromUrl = new URLSearchParams(window.location.search).get('embed') === '1';
    const fromStore = window.sessionStorage.getItem('ma_embed') === '1';
    _cached = fromUrl || fromStore;
    if (_cached) window.sessionStorage.setItem('ma_embed', '1');
  } catch {
    _cached = false;
  }
  return _cached;
}

// Post a message to the parent window (the portal). Safe no-op when not framed.
// With multiple allowed origins we post to each; the browser delivers only to the
// matching parent and drops the rest, so no origin ever receives another's message.
// Outbound messages carry no secrets (ready/resize/needs-token/signout); the
// sensitive inbound direction (ma:token) is origin-validated on receipt.
export function postToParent(message) {
  try {
    if (!(window.parent && window.parent !== window)) return;
    if (PORTAL_ORIGINS.length === 0) { window.parent.postMessage(message, '*'); return; }
    for (const origin of PORTAL_ORIGINS) window.parent.postMessage(message, origin);
  } catch {
    /* ignore */
  }
}
